import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = () => {
  const activities = [
    {
      id: 1,
      type: 'quotation',
      title: 'Nuevo presupuesto creado',
      description: 'Presupuesto #QUO-2024-156 para Cliente ABC S.L.',
      time: 'Hace 15 minutos',
      icon: 'FileText',
      color: 'primary'
    },
    {
      id: 2,
      type: 'invoice',
      title: 'Factura pagada',
      description: 'Factura #INV-2024-089 - €2.450,00 recibido',
      time: 'Hace 32 minutos',
      icon: 'Receipt',
      color: 'success'
    },
    {
      id: 3,
      type: 'stock',
      title: 'Stock bajo detectado',
      description: 'Producto "Laptop Dell XPS 13" - Solo 3 unidades',
      time: 'Hace 1 hora',
      icon: 'AlertTriangle',
      color: 'warning'
    },
    {
      id: 4,
      type: 'delivery',
      title: 'Entrega completada',
      description: 'Albarán #ALB-2024-234 entregado a Empresa XYZ',
      time: 'Hace 2 horas',
      icon: 'Truck',
      color: 'success'
    },
    {
      id: 5,
      type: 'product',
      title: 'Producto agregado',
      description: 'Nuevo producto "Monitor Samsung 27" añadido al catálogo',
      time: 'Hace 3 horas',
      icon: 'Package',
      color: 'primary'
    }
  ];

  const getIconColor = (color) => {
    switch (color) {
      case 'success':
        return 'text-success';
      case 'warning':
        return 'text-warning';
      case 'error':
        return 'text-error';
      case 'primary':
      default:
        return 'text-primary';
    }
  };

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-heading-semibold text-text-primary">
          Actividad Reciente
        </h2>
        <button className="text-sm text-primary hover:text-primary-700 font-body-medium transition-micro">
          Ver todo
        </button>
      </div>

      <div className="space-y-4">
        {activities.map((activity) => (
          <div key={activity.id} className="flex items-start space-x-4 p-3 rounded-lg hover:bg-secondary-50 transition-micro">
            <div className={`p-2 rounded-full bg-secondary-100 ${getIconColor(activity.color)}`}>
              <Icon name={activity.icon} size={16} strokeWidth={2} />
            </div>
            
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-body-medium text-text-primary mb-1">
                {activity.title}
              </h4>
              <p className="text-sm text-text-secondary mb-2 line-clamp-2">
                {activity.description}
              </p>
              <span className="text-xs text-text-muted">
                {activity.time}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;